module.exports = __webpack_public_path__ + "img/icon-tarjeta-outline.261a70ba.svg";